<div class="page">
  <div class="report-header">
    <div class="report-header__title">担当別月間売上</div>
    <button
      class="header__export btn btn--big btn--white btn--outline-gray"
      (click)="exportCSV()"
      [disabled]="exportInProgress"
      *ngIf="showExportButton"
    >
      CSV出力
    </button>
  </div>
  <div class="content">
    <div class="row">
      <ag-sales-report-filter (filter)="updateReportView($event)">
      </ag-sales-report-filter>
      <hr />
      <div
        class="report-content__group report-content__group--golden-title-border"
      >
        <span class="group__header">求人担当・成約請求額</span>
        <ng-content
          *ngTemplateOutlet="
            table_template;
            context: { collection: model.rapa, agentType: 1 }
          "
        >
        </ng-content>
      </div>

      <div
        class="report-content__group report-content__group--golden-title-border"
      >
        <span class="group__header">求職担当・成約請求額</span>

        <ng-content
          *ngTemplateOutlet="
            table_template;
            context: { collection: model.ca, agentType: 3 }
          "
        >
        </ng-content>
      </div>
    </div>
  </div>
</div>

<ng-template #headerTemplate>
  <thead>
    <tr>
      <th class="user-info">チーム名</th>
      <th class="user-info">ユーザ名</th>
      <th class="actual">SN (AG)</th>
      <th class="actual">SN (Plus)</th>
      <th class="yomi">カタ</th>
      <th class="yomi">FCST</th>
      <th class="yomi">★</th>
      <th class="yomi">ノビ</th>
      <th class="actual">SK (AG)</th>
      <th class="actual">SK (Plus)</th>
      <th class="yomi">カタ</th>
      <th class="yomi">FCST</th>
      <th class="yomi">★</th>
      <th class="yomi">ノビ</th>
      <th class="actual">キャンセル金額 (AG)</th>
      <th class="actual">キャンセル金額 (Plus)</th>
    </tr>
  </thead>
</ng-template>

<ng-template
  #table_template
  let-collection="collection"
  let-agentType="agentType"
>
  <table *ngIf="collection.total">
    <ng-content *ngTemplateOutlet="headerTemplate"></ng-content>
    <tbody>
      <tr *ngFor="let row of collection.users">
        <ng-container
          *ngIf="
            userTeamInjector.getUserTeamInfoById(row.userId) | async as user
          "
        >
          <td>{{ user.teamName }}</td>
          <td>{{ user.name }}</td>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.snAg,
                userId: row.userId,
                progressType: 0,
                agentType: agentType
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.snPlus,
                userId: row.userId,
                progressType: 1,
                agentType: agentType
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.snKata,
                userId: row.userId,
                progressType: 0,
                isYomi: true,
                agentType: agentType
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.snFCST,
                userId: row.userId,
                progressType: 1,
                isYomi: true,
                agentType: agentType
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.snHoshi,
                userId: row.userId,
                progressType: 0,
                isYomi: true,
                agentType: agentType
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.snNobi,
                userId: row.userId,
                progressType: 1,
                isYomi: true,
                agentType: agentType
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.skAg,
                userId: row.userId,
                progressType: 0,
                agentType: agentType
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.skPlus,
                userId: row.userId,
                progressType: 1,
                agentType: agentType
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.skKata,
                userId: row.userId,
                progressType: 0,
                isYomi: true,
                agentType: agentType
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.skFCST,
                userId: row.userId,
                progressType: 1,
                isYomi: true,
                agentType: agentType
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.skHoshi,
                userId: row.userId,
                progressType: 0,
                isYomi: true,
                agentType: agentType
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.skNobi,
                userId: row.userId,
                progressType: 1,
                isYomi: true,
                agentType: agentType
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.cancelAg,
                userId: row.userId,
                progressType: 0,
                agentType: agentType,
                canceled: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.cancelPlus,
                userId: row.userId,
                progressType: 1,
                agentType: agentType,
                canceled: true
              }
            "
          ></ng-content>
        </ng-container>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td class="label" colspan="2">合計</td>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: { currency: collection.total?.snAg }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: { currency: collection.total?.snPlus }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: { currency: collection.total?.snKata, isYomi: true   }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: { currency: collection.total?.snFCST, isYomi: true   }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: { currency: collection.total?.snHoshi, isYomi: true   }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: { currency: collection.total?.snNobi, isYomi: true   }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: { currency: collection.total?.skAg }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: { currency: collection.total?.skPlus }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: { currency: collection.total?.skKata, isYomi: true   }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: { currency: collection.total?.skFCST, isYomi: true   }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: { currency: collection.total?.skHoshi, isYomi: true   }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: { currency: collection.total?.skNobi, isYomi: true   }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: {
              currency: collection.total?.cancelAg
            }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            totalCell;
            context: {
              currency: collection.total?.cancelPlus
            }
          "
        ></ng-content>
      </tr>
    </tfoot>
  </table>
</ng-template>

<ng-template
  #currencyCell
  let-value="currency"
  let-userId="userId"
  let-progressType="progressType"
  let-agentType="agentType"
  let-canceled="canceled"
  let-isYomi="isYomi"
>
  <td
    class="currency currency__clickable"
    [routerLink]="['/sales/list']"
    [queryParams]="
      getSearchQueryParams(userId, progressType, agentType, canceled)
    "
  >
    <span *ngIf="!value && value !== 0">-</span>
    <span
      *ngIf="value || value === 0" 
      [ngClass]="{ 'neg-value': value < 0, 'pos-value': value > 0 }"
    >
      {{ value | undef | number: "0.0-2" }}
    </span>
  </td>
</ng-template>

<ng-template
  #totalCell
  let-value="currency"
  let-isYomi="isYomi"
>
  <td
    class="currency"
  >
    <span *ngIf="!value && value !== 0">-</span>
    <span
      *ngIf="value || value === 0" 
      [ngClass]="{ 'neg-value': value < 0, 'pos-value': value > 0 }"
    >
      {{ value | undef | number: "0.0-2" }}
    </span>
  </td>
</ng-template>
